/* eslint-disable no-multi-spaces */
import Vue           from 'vue'
import { mapState }  from 'vuex'
import VueRouter     from 'vue-router'
import { fb }        from './components/common.js'
import router        from './router.js'
import store         from './store'
import globalNav     from './components/view/global-nav.vue'
import cachalog404   from './components/404.js'
import loadingScreen from './components/view-model/loading-screen.vue'
/* eslint-enable */

Vue.use(VueRouter)
Vue.config.productionTip = false

const _app = `
<div id="app">
<global-nav :user="user"></global-nav>
<cachalog-404 v-if="notFound" routeTitle="404 Not Found"></cachalog-404>
<router-view v-else></router-view>
<loading-screen v-if="loading"></loading-screen>
</div>
`

/* eslint-disable-next-line */
new Vue({
  el: '#app',
  template: _app,
  router,
  store,
  components: {
    'global-nav': globalNav,
    'cachalog-404': cachalog404,
    'loading-screen': loadingScreen
  },
  computed: {
    ...mapState([
      'og',
      'cachalogUrl',
      'user',
      'routes',
      'historiesQueue',
      'notFound',
      'errorQueue',
      'asyncQueue',
      'addPageQueue',
      'providerData',
      'backgroundColor'
    ]),
    loading () {
      return this.asyncQueue.length
    }
  },
  watch: {
    user (value) {
      this.$store.dispatch('updateUserHistories')
    },
    historiesQueue (value) {
      if (this.user.uid) {
        this.$store.dispatch('updateUserHistories')
      }
    },
    routes (value) {
      if (value.length) {
        const route = value[0]
        this.$store.commit('dequeueRoute')
        if (route.method === 'replace') {
          this.$router.replace(route)
        } else {
          this.$router.push(route)
        }
      }
    },
    '$route': {
      immediate: true,
      handler () {
        this.$store.commit('notFound', false)
        const html = document.querySelector('html')
        console.log('route.name: ', this.$route.name)
        html.style.backgroundColor = this.backgroundColor[this.$route.name] || '#FCFAF6'
      }
    },
    errorQueue (value) {
      if (value.length) {
        const error = value[0]
        console.error(error.error)
        this.$store.commit('dequeueError')
      }
    },
    addPageQueue (value) {
      if (value.length) {
        this.$store.dispatch('addPageToUser', value[0])
        this.$store.commit('dequeueAddPage')
      }
    }
  },
  methods: {
    debug () {
      console.log('debug store.state: ', this.$store.state)
    }
  },
  created () {
    this.$store.commit('enqueueAsync')
    fb.auth().onAuthStateChanged(user => {
      this.$store.commit('dequeueAsync')
      if (user) {
        console.log('User is signed in.')
        this.$store.commit('storeProviderData', user)
        if (!this.providerData.isAnonymous) {
          if (localStorage.uid) {
            this.$store.dispatch('createTransfer', [user.uid, localStorage.uid])
          }
          if (location.href.match(/[?&]destination=([^&]+)/)) {
            const destination = decodeURIComponent(location.href.match(/[?&]destination=([^&]+)/)[1])
            this.$router.push({path: destination.replace(this.cachalogUrl, '/')})
          }
        }
        this.$store.dispatch('fetchUserWithPrivate', user)
      } else {
        console.log('No user is signed in.')
      }
    })
  }
})



// WEBPACK FOOTER //
// ./src/main.js